import { SalesDeliveryStatus } from "./enums/sales-delivery-status.enum";

export const SalesDeliveryStatusLabels=[
{
    key:SalesDeliveryStatus.Draft.toString(),
    textClass: 'text-blue-600',
    bgClass: 'bg-blue-600/10',
},{
    key:SalesDeliveryStatus.Completed.toString(),
    textClass: 'text-indigo-600',
    bgClass: 'bg-indigo-600/10',
},
{
    key:SalesDeliveryStatus.Synced.toString(),
    textClass: 'text-yellow-600',
    bgClass: 'bg-yellow-600/10',
},
]